// extracted by mini-css-extract-plugin
export default {"reviews":"reviews_reviews__uYsKa","title":"reviews_title__fLywu","wrapper":"reviews_wrapper__0lNB0","wrap":"reviews_wrap__w7RjU"};